export const STRIPE_PUBLISHABLE_KEY = 'pk_test_T7jZ7quEj8SZY6jCZUqk9Eqm';

//test: pk_test_T7jZ7quEj8SZY6jCZUqk9Eqm

//live: pk_live_WLvVqmKpANngccooJoS4T2e1
